import { AfterViewInit, Directive, ElementRef, Input, OnInit, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, ValidatorFn } from '@angular/forms';

import { toKebabCase } from '@utils/string-utils';
import { UntilDestroy } from '@ngneat/until-destroy';

@Directive()
@UntilDestroy()
export abstract class AbstractFormComponent implements OnInit, AfterViewInit {
  protected otherValidators: ValidatorFn[] = [];

  formGroup: UntypedFormGroup | undefined;
  formControl = new UntypedFormControl();

  @Input() tid = '';
  @Input() label = '';
  @Input() hideLabel = false;
  @Input() placeholder = '';
  @Input() formPropertyName: string | undefined = undefined;
  /** When set, binds this control directly instead of resolving {@link formPropertyName} from the parent form group. */
  @Input() formControlOverride?: UntypedFormControl;
  @Input() readonly = false;
  @Input() requiredField = false;
  @Input() emailField = false;

  constructor(
    protected elementRef: ElementRef,
    @Optional() protected formGroupDirective: FormGroupDirective
  ) {}

  ngOnInit() {
    if (this.formControlOverride) {
      this.formControl = this.formControlOverride;
      return;
    }

    if (!this.formGroupDirective?.control || !this.formPropertyName) {
      console.error('formPropertyName is required for form control when formControlOverride is not set');
      return;
    }

    this.formGroup = this.formGroupDirective.control;
    this.formControl = this.formGroup.get(this.formPropertyName) as UntypedFormControl;
  }

  ngAfterViewInit(): void {
    if (this.otherValidators.length) {
      const validators = [...this.otherValidators];
      if (this.formControl.validator) validators.push(this.formControl.validator);
      this.formControl.setValidators(validators);
    }

    this.createTestIdentificationAttribute();
  }

  private createTestIdentificationAttribute() {
    const id = toKebabCase(this.tid);
    this.elementRef.nativeElement.setAttributeNode(document.createAttribute(`data-tid-${id}-field`));
  }
}
